(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mz-phone-carrier"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mz-phone-carrier')) {
customElements.define('mz-phone-carrier', class extends HTMLElement {
  connectedCallback() {
    this.select=this.querySelector('[data-mz-phone-carrier]');
    this.payment=this.querySelector('[data-mz-payment]');
    this.info=this.closest('product-info');
    this.prices=JSON.parse(this.querySelector('[data-carrier-prices]').textContent);
    this.onChange=()=>this.choose();
    this.select.addEventListener('change',this.onChange);
    this.payment?.addEventListener('change',()=>{
      if((this.payment.value||'').toLowerCase().includes('lease')){
        window.location.href='/pages/apply-for-lease';
        return;
      }
      this.onChange();
    });
    this.observer=new MutationObserver(()=>this.sync());
    if(this.info)this.observer.observe(this.info,{childList:true,subtree:true});
    this.sync();
    if(this.dataset.priced==='true' && this.select.options.length>1){
      this.select.value='T-Mobile';
      if(this.payment)this.payment.value='Pay in Full';
      this.choose();
    }
  }
  native(){return this.info?.querySelector('[data-mz-native-purchase]');}
  choose(){
    const native=this.native();
    if(!native){this.sync();return;}
    const carrier=this.select.value;
    if(carrier!=='Unlocked' && this.payment.value!=='Pay in Full')this.payment.value='Pay in Full';
    const mappedCarrier=carrier==='Metro PCS'?'T-Mobile':carrier==='Cricket'?'AT&T':carrier;
    const value=this.payment.value+(carrier==='Unlocked'?'':' · '+mappedCarrier);
    if(!Array.from(native.options).some(o=>o.value===value))return;
    native.value=value;
    this.querySelector('[data-carrier-selection]').textContent=carrier;
    this.querySelector('[data-carrier-price]').textContent='…';
    native.dispatchEvent(new Event('change',{bubbles:true}));
  }
  setText(selector,text){const el=this.querySelector(selector);if(el.textContent!==text)el.textContent=text;}
  sync(){
    const native=this.native();
    if(native){
      const [payment,carrier='Unlocked']=native.value.split(' · ');
      this.select.value=carrier;
      this.payment.value=payment;
      Array.from(this.payment.options).forEach(o=>{o.disabled=carrier!=='Unlocked'&&o.value!=='Pay in Full';});
    }
    const form=document.getElementById(this.dataset.formId);
    const variantId=form?.querySelector('[name="id"]')?.value;
    const variantNode=this.info?.querySelector('variant-selects [data-selected-variant]');
    let selected=null;try{selected=JSON.parse(variantNode?.textContent||'null');}catch{}
    this.setText('[data-carrier-selection]',this.select.value);
    this.setText('[data-carrier-price]',selected?this.prices[String(selected.id)]||'':this.querySelector('[data-unavailable]').content.textContent);
  }
  disconnectedCallback(){this.observer?.disconnect();this.select?.removeEventListener('change',this.onChange);this.payment?.removeEventListener('change',this.onChange);}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mz-purchase-options"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mz-purchase-options'))customElements.define('mz-purchase-options',class extends HTMLElement{
 connectedCallback(){
  const title=(this.dataset.productTitle||'').toLowerCase();
  const info=this.closest('product-info');
  const isIphone=title.includes('iphone');
  const olderBaseOnly=isIphone && (
    title.includes('iphone 7') || title.includes('iphone 8') || title.includes('iphone x') ||
    title.includes('iphone xr') || title.includes('iphone xs') || title.includes('iphone 11') ||
    (title.includes('iphone 12') && !title.includes('12 pro'))
  );
  if(olderBaseOnly){
    const selectors=info?.querySelectorAll('variant-selects .product-form__input')||[];
    selectors.forEach(group=>{
      const label=(group.querySelector('.form__label')?.textContent||'').toLowerCase();
      if(label.includes('storage')){
        const select=group.querySelector('select');
        if(select){
          Array.from(select.options).forEach((o,i)=>{if(i>0)o.hidden=true;});
          select.selectedIndex=0;
          select.dispatchEvent(new Event('change',{bubbles:true}));
        }else{
          const inputs=Array.from(group.querySelectorAll('input'));
          inputs.forEach((el,i)=>{if(i>0){el.hidden=true;const lab=group.querySelector('label[for="'+el.id+'"]');if(lab)lab.hidden=true;}});
          if(inputs[0])inputs[0].click();
        }
      }
      if(title.includes('iphone 7') && label.includes('color')){
        const select=group.querySelector('select');
        if(select){
          let chosen=false;
          Array.from(select.options).forEach(o=>{const ok=/black/i.test(o.value);o.hidden=!ok;if(ok&&!chosen){o.selected=true;chosen=true;}});
          select.dispatchEvent(new Event('change',{bubbles:true}));
        }
      }
    });
  }
  this.querySelector('[data-pay-full]').addEventListener('click',()=>{
  const info=this.closest('product-info');
  const payment=info?.querySelector('[data-mz-payment]');
  if(payment){payment.value='Pay in Full';payment.dispatchEvent(new Event('change',{bubbles:true}));return;}
  const native=info?.querySelector('[data-mz-native-purchase]');
  if(native){native.value='Pay in Full';native.dispatchEvent(new Event('change',{bubbles:true}));return;}
  const input=Array.from(info?.querySelectorAll('variant-selects input')||[]).find(el=>el.value==='Pay in Full');
  if(input)input.click();
 });}
});
  } catch(e) { console.error(e); }
})();

})();
